<template>
  <div>
    <el-select style="width:100%;" id="bank_info" v-model="bank_info" @change="change" :placeholder="$t('deposit.upload.please_sel')">
      <el-option v-for="(item,key) in list" v-show="item.value != 'bankInfo.undefined'" :key="key" :label="item.label" :value="item.value"></el-option>
      <!-- <el-option v-for="(item,key) in list" v-show="item.value != 'bankInfo.undefined' && item.value != '7853658' && item.value != '7025975' && item.value != '4009940'" :key="key" :label="item.label" :value="item.value"></el-option> -->
    </el-select>
  </div>
</template>
<script>
import countryCodes from 'country-code-info'
import bankInfo from '@/js/bankInfo'
import _ from 'lodash'
import { mapGetters } from 'vuex'
export default {
  props: ['bank', 'type'],
  data () {
    return {
      list: [],
      subList: [],
      eddidList: [],
      bank_info: this.bank,
      dialogVisible: false,
      showClose: true,
      contiune: true
    }
  },
  watch: {
    type: {
      handler (val) {
        this.intData()
        this.bank_info = ''
        this.$emit('change', '', '--')
      }
    },
    subList: {
      handler (val) {
        if (bankInfo[this.type]) {
          this.addBankInfo(bankInfo[this.type])
        } else {
          this.list = this.subList
        }
      }
    }
  },
  computed: {
    ...mapGetters(['getAccountInfo', 'getClientProfile']),
    nationality () {
      return this.getClientProfile && this.getClientProfile.userInfo ? this.getClientProfile.userInfo.issuingCountry : ''
    }
  },
  methods: {
    intData () {
      if (
        (
          countryCodes.findCountry({
            a3: this.nationality
          }) || {
            name: ''
          }
        ).name === 'China'
      ) {
        this.getBankInfo()
      } else {
        this.subList = []
      }
    },
    getBankInfo () {
      this.subList = []
      this.$api
        .getsubAccount({
          sortKey: 'createdTime',
          sortVal: '-1',
          searchParams: {
            accountNumber: this.$getProfile().custom.accountNumber,
            status: 'completed',
            isLock: true
          }

          // accountNumber: this.$getProfile().custom.accountNumber,
          // status: 'completed'
        })
        .then(result => {
          let arr = result.data.rows
          for (let i = 0; i < arr.length; i++) {
            let item = {}
            item.label = arr[i].bankName + ' | ' + arr[i].bankSubBAccountNumber
            item.value = arr[i].bankSubBAccountNumber
            item.currency = arr[i].currency
            this.subList.push(item)
          }
        })
    },
    change (val) {
      const index = _.findIndex(this.list, function (o) {
        return o.value === val
      })
      const obj = this.list[index]
      console.log('>>>>>>>>>>>>>>>>>>>obj', obj)
      this.$emit('change', val, obj['currency'], obj['label'].split('|')[0])
    },
    addBankInfo (list) {
      this.eddidList = []
      for (let value of list) {
        let item1 = {}
        item1.label =
          this.$t('bankInfo.' + value.accTitleHK) +
          ' | ' +
          this.$t('bankInfo.' + value.accHK)
        item1.value = this.$t('bankInfo.' + value.accHK)
        item1.currency = this.$t('bankInfo.' + value.currencyHK)
        this.eddidList.push(item1)
        let item2 = {}
        item2.label =
          this.$t('bankInfo.' + value.accTitleUS) +
          ' | ' +
          this.$t('bankInfo.' + value.accUS)
        item2.value = this.$t('bankInfo.' + value.accUS)
        item2.currency = this.$t('bankInfo.' + value.currencyUS)
        this.eddidList.push(item2)
        let item3 = {}
        item3.label =
          this.$t('bankInfo.' + value.accTitleCN) +
          ' | ' +
          this.$t('bankInfo.' + value.accCN)
        item3.value = this.$t('bankInfo.' + value.accCN)
        item3.currency = this.$t('bankInfo.' + value.currencyCN)
        this.eddidList.push(item3)
      }
      this.list = _.concat(this.subList, this.eddidList)
    }
  }
}
</script>

<style scoped>
@media (max-width: 768px) {
  .el-popper {
    max-width: 350px;
    left: 10px !important;
  }
  .el-select-dropdown__item {
    font-size: 12px;
    padding: 6px 10px;
  }
}
</style>
